import React, { useEffect, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import Container from '../../../../components/Container'
import api from '../../../../services/api'
import { useToast } from '../../../../hooks/toast'
import { useLoading } from '../../../../hooks/loading'
import { Alert } from '../../../../components/Alert'
import { nameActions } from '../domain/info'
import { apiDelete, apiList } from '../domain/api'
import { breadcrumbView } from '../domain/breadcrumb'
import { toolsViewUpdate, toolsViewList } from '../domain/tools'
import { INPUT_MASK } from '../../../../common/constants'
import moment from 'moment'

export const CLIENT_TYPE_TRANSLATED = {
  client: 'Cliente',
  indicator: 'Indicador',
  both: 'Cliente e Indicador'
}

const ClientsView = (): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const location = useLocation()
  const { addToast } = useToast()

  const { disableLoading, activeLoading } = useLoading()
  const [clients, setClients] = useState<ClientsApiResponse | null>(null)

  useEffect(() => {
    activeLoading()
    async function loadClients(): Promise<void> {
      activeLoading()
      try {
        const responseClient = await api.get<ClientsApiResponse>(apiList(id))
        setClients({ ...responseClient.data })

        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o cliente',
          description:
            'Houve um error ao carregar o cliente, tente novamente mais tarde!'
        })
        if (path.includes('view')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadClients()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLoading, addToast, disableLoading, history, location.pathname])

  const [alertRemoveParent, setAlertRemoveParent] = useState(false)

  const handleOnClickRemoveParent = () => {
    setAlertRemoveParent(true)
  }

  const handlerOnClickButtonConfirmRemoveParent = async (id: number) => {
    try {
      await api.delete(apiDelete(String(id)))
      setAlertRemoveParent(false)
      addToast({
        type: 'success',
        title: 'Cliente removido com sucesso.'
      })
      history.goBack()
    } catch (err: any) {
      setAlertRemoveParent(false)
      if (err.response.status === 403) {
        addToast({
          type: 'error',
          title: err.response.data.message
        })
        return
      }
      addToast({
        type: 'error',
        title: 'Cliente não removido, pois ainda está sendo usada.'
      })
    }
  }

  const handlerOnClickButtonCancelRemoveParent = () => {
    setAlertRemoveParent(false)
  }

  return (
    <div className="d-flex flex-column container-fluid">
      <>
        <Container
          pageTitle={nameActions.read.name}
          breadcrumb={breadcrumbView}
          tools={[
            toolsViewUpdate(String(id)),
            // toolsViewDelete(() => {
            //   handleOnClickRemoveParent()
            // }),
            // toolsViewCreate(),
            toolsViewList()
          ]}
        >
          <div className="form-body">
            <div className="row mb-5">
              <div className="col-md-1">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Cód.
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">{clients?.id}</p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Nome
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.name}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    CPF
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">{clients?.cpf}</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Nascimento
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {moment(clients?.birth_date).format(INPUT_MASK.DATE_LOCALE)}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Email
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.email}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Celular
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.cell_phone}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Cep
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.zip_code}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Rua
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.street}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Número
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.number}
                  </p>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Cidade
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.city}
                  </p>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Bairro
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.district}
                  </p>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Estado
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">{clients?.uf}</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Complemento
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.complement || 'Não informado'}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Origem
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.clientOrigin?.name || 'Não informado'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Tipo de cliente
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {CLIENT_TYPE_TRANSLATED[clients?.type as ClientsType] ||
                      'Não informado'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Agência de viagem
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.agency_name || 'Não informado'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    CPF/CNPJ do titular da conta bancária
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.bank_cnpj_cpf_account_holder || 'Não informado'}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Banco
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.bank_code || 'Não informado'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Agência
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.bank_agency || 'Não informado'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Conta
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.bank_account || 'Não informado'}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label
                    htmlFor="id"
                    className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                  >
                    Chave Pix
                  </label>
                  <p className="fw-bolder fs-6 text-gray-800">
                    {clients?.bank_pix_key || 'Não informado'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>

        <Alert
          message={`Tem certeza que deseja excluir o registro ${clients?.id} ?`}
          onClickCancellButton={handlerOnClickButtonCancelRemoveParent}
          onClickConfirmButton={() =>
            handlerOnClickButtonConfirmRemoveParent(Number(clients?.id))
          }
          isActive={alertRemoveParent}
        />
      </>
    </div>
  )
}

export default ClientsView
